import React, { useEffect, useState } from "react";
import { AnimatedAcaiLogo } from "./AcaiLogo";
import "./opening.css";

// Decorative startup layer only: authentication starts immediately underneath.
// Ready content is interactive even during the short exit fade. No storage,
// provider calls, or route-change listeners; invitation links bypass AuthGate.
export function OpeningScreen({ loading }) {
  const [visible, setVisible] = useState(loading);
  const [dismissed, setDismissed] = useState(!loading);
  const [assetState, setAssetState] = useState("loading");
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.onload = () => setAssetState("ready");
    image.onerror = () => setAssetState("failed");
    image.src = "/assets/acai-logo-white-transparent.png";
    return () => { image.onload = null; image.onerror = null; };
  }, []);
  useEffect(() => { if (!loading) setDismissed(true); }, [loading]);
  useEffect(() => {
    if (!dismissed) return;
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const timer = setTimeout(() => setVisible(false), reduced ? 0 : 180);
    return () => clearTimeout(timer);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const timer = setTimeout(() => setSlow(true), 1500);
    return () => clearTimeout(timer);
  }, [dismissed]);

  if (!visible) return null;
  return <div className={`opening-screen${dismissed ? " is-dismissed" : ""}`} aria-hidden="true" data-testid="opening-screen">
    <div className="opening-brand">
      <div className="opening-halo" />
      {assetState === "ready" && <AnimatedAcaiLogo />}
      {assetState === "failed" && <span className="opening-fallback">ACAI</span>}
      {slow && !dismissed && <p className="opening-loading"><span />Avataan assistenttia…</p>}
    </div>
  </div>;
}
